enum StagedImportFileType {
  TIME_REGISTRATIONS = 'time-registrations',
  FREELANCERS_FEE = 'freelancers-fee',
  DANLOEN = 'danloen',
  PROLOEN = 'proloen',
}
export default StagedImportFileType
